// Convert a research report into Markdown / plain text and trigger downloads.

export function reportToMarkdown(report) {
  if (!report) return "";

  const lines = [];
  lines.push(`# ${report.query}`);
  lines.push("");
  lines.push(
    `*Generated by NeuroScout AI - ${new Date(report.created_at).toLocaleString()} - ${
      report.mode || "balanced"
    } mode - ${report.search_iterations} search iterations - ${report.generation_time_sec}s*`,
  );
  lines.push("");

  lines.push("## Executive Summary");
  lines.push("");
  lines.push(report.executive_summary || "");
  lines.push("");

  (report.sections || []).forEach((section) => {
    lines.push(`## ${section.heading}`);
    lines.push("");
    lines.push(section.content || "");
    lines.push("");
  });

  if ((report.key_takeaways || []).length > 0) {
    lines.push("## Key Takeaways");
    lines.push("");
    report.key_takeaways.forEach((item) => lines.push(`- ${item}`));
    lines.push("");
  }

  if (report.critical_insight) {
    lines.push("## Critical Insight");
    lines.push("");
    lines.push(report.critical_insight);
    lines.push("");
  }

  if ((report.common_misconceptions || []).length > 0) {
    lines.push("## Common Misconceptions");
    lines.push("");
    report.common_misconceptions.forEach((item) => lines.push(`- ${item}`));
    lines.push("");
  }

  if ((report.conflicting_evidence || []).length > 0) {
    lines.push("## Conflicting Evidence");
    lines.push("");
    report.conflicting_evidence.forEach((item) => {
      lines.push(`- **${item.topic}**: ${item.summary}`);
    });
    lines.push("");
  }

  if ((report.evidence_gaps || []).length > 0) {
    lines.push("## Evidence Gaps");
    lines.push("");
    report.evidence_gaps.forEach((item) => {
      if (typeof item === "object" && item.gap) {
        lines.push(`- **${item.gap}**`);
        if (item.reason) lines.push(`  - *Why missing:* ${item.reason}`);
        if (item.needed) lines.push(`  - *Needed:* ${item.needed}`);
      } else {
        lines.push(`- ${item}`);
      }
    });
    lines.push("");
  }

  if (report.confidence_summary?.overall) {
    lines.push("## Confidence");
    lines.push("");
    lines.push(
      `**${report.confidence_summary.overall}** - ${report.confidence_summary.rationale || ""}`,
    );
    lines.push("");
  }

  lines.push("## References");
  lines.push("");
  (report.references || []).forEach((reference) => {
    lines.push(
      `${reference.id}. [${reference.title}](${reference.url}) - ${
        reference.source_type || "general"
      } - quality ${reference.source_quality_score ?? "n/a"} - accessed ${new Date(
        reference.accessed_date,
      ).toLocaleDateString()}`,
    );
  });

  return lines.join("\n");
}

export function reportToText(report) {
  return reportToMarkdown(report)
    .replace(/^#+\s+/gm, "")
    .replace(/\*\*/g, "")
    .replace(/\*/g, "")
    .replace(/\[(.+?)\]\((.+?)\)/g, "$1 ($2)");
}

export function downloadFile(filename, content, mime = "text/plain") {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
